module.exports = __webpack_public_path__ + "7a34c5b7f462fd60e6785097db9ad077.png";